import { None, Some } from "../../../../misc/option";
export class BucketUICollection {
    constructor() {
        this._buckets = [];
    }
    all_on() {
        this._buckets.forEach(b => b.enable());
    }
    all_off() {
        this._buckets.forEach(b => b.disable());
    }
    all_off_except(name) {
        this.all_off();
        this.turn_on(name);
    }
    turn_on(name) {
        this.get(name).map(b => b.enable());
    }
    turn_off(name) {
        this.get(name).map(b => b.disable());
    }
    add(b) {
        this._buckets.push(b);
        return this._buckets.length;
    }
    remove(name) {
        this._buckets = this._buckets.filter(b => b.label !== name);
        return this._buckets.length;
    }
    get(name) {
        let item = this._buckets.find(b => b.label === name);
        if (typeof item === "undefined")
            return None.instance();
        return new Some(item);
    }
    inverted_on(name) {
        let bucket = this.get(name);
        return bucket.map(b => {
            let all_except = this._buckets.filter(bb => bb.label !== b.label);
            return b.isEnabled && all_except.every(bb => !bb.isEnabled);
        }).unwrapOr(false);
    }
}
